import React, {useState, useEffect, useRef} from 'react'
import {
    ShoppingCartContainer, 
    ShoppingCartTitle, 
    ShoppingCartHeader,
    ShoppingCartList,
    CloseContainer,
    ButtonCart,
    EmptyCart
} from './style'
import {CartProductList} from './utils'
import { useSelector, useDispatch } from 'react-redux'
import {RootState} from '../../redux/reducers/index'
import {handleHideCart, handleRemoveProduct} from '../../redux/actions/shoppingCartActions'
import { captureCartReturnPath } from '../../utils/cartReturnPath'
import useOnClickOutside from '../../hooks/useOnClickOutside'
import { path, domain } from '../../config/enviroment';
// import MainButton from '../MainButton'
import {useHistory, useLocation} from "react-router-dom";
// import { Close } from '../MainModal/Close'
import CloseIcon from '../CloseIcon'
import {Share} from '../share'
import { language } from '../../utils/language'


const ShoppingCart = () => {

    
    // const theme = useSelector((state: any) => state.theme)
    const homeState: HomeStateType = useSelector((state: RootState) => state.home)
    const shoppingCartState: ShoppingCartStateType = useSelector((state: RootState) => state.shoppingCart)    
    const [render, setRender] = useState(shoppingCartState.show)
    
    const dispatch = useDispatch()
    const wrapperRef = useRef(null);
    const history = useHistory();
    const location = useLocation()
    // const { idProduct, idCatalog, idCart}: any = useParams()
    

    const handleClickOutside = () => {

        dispatch(handleHideCart())
    }

    const removeProduct = (position: number, lastProduct: boolean = false, idRef: any = "", productId: number) => {
        dispatch(handleRemoveProduct(productId, shoppingCartState.id, path, idRef, homeState.default_language, lastProduct, homeState.catalogueName, history))    
    }
    
    const onAnimationEnd = () => {
        if (!shoppingCartState.show) setRender(false)
    }
    

    useOnClickOutside(wrapperRef, handleClickOutside)

    useEffect(() => {
        if (shoppingCartState.show) {
            setRender(true)
        }
        return () => {
        }
    
    }, [shoppingCartState.show])

    return (
        <>
            {


                render && 

                    <ShoppingCartContainer ref={wrapperRef} onAnimationEnd={onAnimationEnd} show={shoppingCartState.show}>
                        <ShoppingCartHeader>
                            <ShoppingCartTitle>
                                <div>{language[homeState.default_language]["shoppingCart"]}</div>
                                {
                                    shoppingCartState.cartInfo.length > 0
                                    ? <Share url={`${domain}/vende/${homeState.catalogueUrlName}/carrito/${shoppingCartState.id}`} color={homeState.color} outlined={true} />
                                    : <></>
                                }
                                <CloseContainer>
                                    <CloseIcon closeAction={() => dispatch(handleHideCart())}/>                                    
                                </CloseContainer>
                            </ShoppingCartTitle>
                            
                        </ShoppingCartHeader>
                        {
                            shoppingCartState.cartInfo.length === 0 ?
                                <ShoppingCartList>
                                    <EmptyCart>
                                        {language[homeState.default_language]["shoppingCartEmpty"]}
                                    </EmptyCart>
                                </ShoppingCartList>
                            :
                                <ShoppingCartList>                                    
                                    <CartProductList data={shoppingCartState.cartInfo} 
                                        color={homeState.color}
                                        loading={shoppingCartState.loading}
                                        onDelete={removeProduct}
                                        show={shoppingCartState.show}
                                    />  
                                </ShoppingCartList>
                        }
                        <ButtonCart 
                            color={homeState.color} 
                            secondary={false} 
                            onClick={ () => history.push(
                                shoppingCartState.cartInfo.length > 0 ?
                                    `/vende/${homeState.catalogueUrlName}/carrito/${shoppingCartState.id}`
                                :
                                    `/vende/${homeState.catalogueUrlName}/carrito/empty`
                                ,
                                { from: captureCartReturnPath() }
                            )  }
                        >
                            {language[homeState.default_language]["viewCart"]}
                        </ButtonCart>
                    </ShoppingCartContainer>
            }
        </>
    )
}

export default ShoppingCart